// removed by extract-text-webpack-plugin
module.exports = {"my-loading":"my-loading___2af1c"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/Loading/style.less
// module id = ./src/widget/Loading/style.less
// module chunks = 43